export default __webpack_public_path__ + "files/arkansas-9e81613df6791f92b6148bd5100decb3.png";